import { assertCondition } from '../../../../../utils/types';
import { SimpleCohortTypeKey } from '../../../../../utils/apollo/graphqlSchema';
import { useAppSelector } from '../../../../../redux/hooks';
import { cohortConfigTypeSelector } from '../../../../../redux/selectors/builder';
import { CohortRowRelatedInfo } from '../CohortRowUI';
import {
  useCohortRowContext,
  useCohortRowOperatorAndValues,
} from '../CohortRowContext';
import CohortRowOperatorMenu from './CohortRowOperatorMenu';
import CohortRowBetweenOperatorValues from './CohortRowBetweenOperatorValues';
import CohortRowSingleOperatorValue from './CohortRowSingleOperatorValue';

const CohortRowOperators = () => {
  const { cohortRow, isTimeToConvertRow } = useCohortRowContext();
  const { simpleCohortTypeKey } = cohortRow;
  const { operator } = useCohortRowOperatorAndValues();
  const cohortConfig = useAppSelector((state) =>
    cohortConfigTypeSelector(state, simpleCohortTypeKey),
  );
  assertCondition(
    simpleCohortTypeKey === SimpleCohortTypeKey.Measure ||
      simpleCohortTypeKey === SimpleCohortTypeKey.Performed ||
      simpleCohortTypeKey === SimpleCohortTypeKey.Expression ||
      simpleCohortTypeKey === SimpleCohortTypeKey.Funnel,
  );

  return (
    <CohortRowRelatedInfo>
      <CohortRowOperatorMenu
        operators={
          isTimeToConvertRow && cohortConfig.__typename === 'FunnelCohortConfig'
            ? cohortConfig.ttcConfig.operators
            : cohortConfig.operators
        }
      />
      {operator !== 'TRUE' &&
        operator !== 'FALSE' &&
        (operator === 'BETWEEN' ? (
          <CohortRowBetweenOperatorValues />
        ) : (
          <CohortRowSingleOperatorValue />
        ))}
    </CohortRowRelatedInfo>
  );
};

export default CohortRowOperators;
